define(function aoflUniqueIdServiceModule() {
  'use strict';

  var aoflUniqueIdService = function aoflUniqueIdService(
    $rootScope,
    $state,
    appOptions
  ) {
    var id = 1;
    var routes = {};

    for (var key in appOptions.states.state) {
      if (!appOptions.states.state.hasOwnProperty(key)) {
        continue;
      }
      routes[key] = {
        base: id * 10000,
        curr: 0
      };
      id++;
    }

    $rootScope.$on('$stateChangeSuccess', function stateChangeHandler(
      event,
      toState
    ) {
      routes[toState.name].curr = 0;
    });

    var UniqueIdGen = {
      generate: function generate() {
        return (
          'aofl-' +
          routes[$state.current.name].base +
          ++routes[$state.current.name].curr
        );
      }
    };

    return UniqueIdGen;
  };

  return aoflUniqueIdService;
});
